import React, { useEffect, useState } from 'react'


export default function Drower(props) {


  const handelClose=()=>{
    const drower = document.getElementById(`dr-${props.title}`);
    const contDrower = document.getElementById(`dr-cont-${props.title}`);
    window.addEventListener('click', function (e) {
        if (drower.contains(e.target)){
            if (!contDrower.contains(e.target)) {
                props.setVisible(false)
            }
        }
    });
}


React.useEffect(() => {
    handelClose()
}, [])

  return (
    <>
    <div className={`bg-drower ${props.visible && 'bg-drower-active'}`}></div>
    <div id={`dr-${props.title}`} className={` drower max-w-screen-sm m-auto ${props.visible == true && 'drower-active'}`}>
      <div id={`dr-cont-${props.title}`} className="drower-cont">
        <div className='drower-cont-head'>{props.name}</div>
        <div className='drower-cont-inner pt-4 min-h-[50vh]'>
          {props.children}
        </div>
      </div>
    </div>
    </>
  )
}